import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";

const taxOffice = dictionary.extend({
  code: z.coerce.number().min(1),
  name: z.string().min(1),
});

export const readTaxOffice = taxOffice.readonly();
export const writeTaxOffice = taxOffice.omit({ id: true });
